import { ComponentProps, PropsWithChildren } from 'react';
import Image from 'next/image';
import clsx from 'clsx';

type Props = {
  variant?: 'default' | 'orange';
};

function MeshContainer(props: PropsWithChildren<Props & ComponentProps<'div'>>) {
  const { variant = 'default', children, className, ...rest } = props;

  let imageUrl = '/backgrounds/mesh.svg';

  if (variant === 'orange') {
    imageUrl = '/backgrounds/mesh-orange.svg';
  }

  return (
    <div {...rest} className={clsx('mesh-container', className)}>
      <Image className='mesh-container__image' src={imageUrl} alt='' width={800} height={100} />
      {children}
      <Image className='mesh-container__image' src={imageUrl} alt='' width={800} height={100} />
    </div>
  );
}

export default MeshContainer;
